export default __webpack_public_path__ + "static/media/1618.5c935917.png";